import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from './LanguageSwitcher'
import logoImg from '../assets/logo.png'
import config from '../config'

export const Header: React.FC = () => {
  const { t } = useTranslation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' })
    setIsMenuOpen(false)
  }

  const redirectToApp = () => {
    const mainAppUrl = import.meta.env.VITE_MAIN_APP_URL || 'https://app.nazwolab.pl'
    window.location.href = mainAppUrl
  }

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="max-w-6xl mx-auto px-4 py-2">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img src={logoImg} alt="nazwolab.pl logo" className="h-10 object-contain" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('demo')}
              className="text-gray-700 hover:text-gray-900 transition-colors"
            >
              {t('nav.generator')}
            </button>
            {config.features.pricingVisible && (
              <Link
                to="/pricing"
                className="text-gray-700 hover:text-gray-900 transition-colors"
              >
                {t('nav.pricing')}
              </Link>
            )}
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-gray-900 transition-colors"
            >
              {t('nav.features')}
            </button>
            <LanguageSwitcher />
            <button
              onClick={redirectToApp}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              {t('nav.openApp')}
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2"
          >
            <div className="w-6 h-6 flex flex-col justify-between">
              <span className={`h-0.5 bg-gray-900 transition-all ${isMenuOpen ? 'rotate-45 translate-y-2.5' : ''}`}></span>
              <span className={`h-0.5 bg-gray-900 transition-all ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`h-0.5 bg-gray-900 transition-all ${isMenuOpen ? '-rotate-45 -translate-y-2.5' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pt-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('demo')}
                className="text-left text-gray-700 hover:text-gray-900 transition-colors"
              >
                {t('nav.generator')}
              </button>
              {config.features.pricingVisible && (
                <Link
                  to="/pricing"
                  className="text-left text-gray-700 hover:text-gray-900 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {t('nav.pricing')}
                </Link>
              )}
              <button
                onClick={() => scrollToSection('features')}
                className="text-left text-gray-700 hover:text-gray-900 transition-colors"
              >
                {t('nav.features')}
              </button>
              <div className="py-2">
                <LanguageSwitcher />
              </div>
              <button
                onClick={redirectToApp}
                className="text-left bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors w-fit"
              >
                {t('nav.openApp')}
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}